const defaultColor = "#393939";
const defaultWidth = 20;
const defaultHeight = 20;

export const AmenityIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M8.64108 15.2781C8.64108 14.5152 9.26647 13.8898 10.0295 13.8898C10.7924 13.8898 11.4178 14.5152 11.4178 15.2781C11.4178 16.0411 10.7924 16.6665 10.0295 16.6665C9.26647 16.6665 8.64108 16.0411 8.64108 15.2781ZM18.147 8.69902C18.4222 8.44886 18.4472 8.01109 18.1971 7.72341C14.0194 3.22059 6.97754 2.95793 2.46222 7.13554C2.26209 7.32316 2.06197 7.52328 1.87435 7.72341C1.59918 7.99858 1.59918 8.43635 1.87435 8.69902C2.14952 8.97419 2.58729 8.97419 2.84996 8.69902C2.86247 8.68651 2.87497 8.674 2.88748 8.6615C6.55228 4.72153 12.7186 4.48388 16.6586 8.14867C16.8337 8.31128 17.0088 8.48639 17.1714 8.6615C17.4341 8.93667 17.8719 8.94918 18.147 8.69902ZM14.6699 12.0386C14.945 11.7885 14.97 11.3507 14.7074 11.063C12.3184 8.48639 8.29086 8.32378 5.71425 10.7128C5.58917 10.8253 5.4766 10.9504 5.36403 11.063C5.08886 11.3382 5.08886 11.7759 5.36403 12.0386C5.6392 12.3138 6.07698 12.3138 6.33964 12.0386C6.35215 12.0261 6.36466 12.0136 6.37717 12.0011C8.25334 9.97482 11.4178 9.86225 13.4441 11.7509C13.5316 11.8385 13.6192 11.9135 13.6942 12.0011C13.9569 12.2763 14.3822 12.3013 14.6699 12.0386Z"
        fill={color}
      />
    </svg>
  );
};

export const ReviewIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M11.4421 2.9252L12.9087 5.85853C13.1087 6.26686 13.6421 6.65853 14.0921 6.73353L16.7504 7.1752C18.4504 7.45853 18.8504 8.69186 17.6254 9.90853L15.5587 11.9752C15.2087 12.3252 15.0171 13.0002 15.1254 13.4835L15.7171 16.0419C16.1837 18.0669 15.1087 18.8502 13.3171 17.7919L10.8254 16.3169C10.3754 16.0502 9.63375 16.0502 9.17541 16.3169L6.68375 17.7919C4.90041 18.8502 3.81708 18.0585 4.28375 16.0419L4.87541 13.4835C4.98375 13.0002 4.79208 12.3252 4.44208 11.9752L2.37541 9.90853C1.15875 8.69186 1.55041 7.45853 3.25041 7.1752L5.90875 6.73353C6.35041 6.65853 6.88375 6.26686 7.08375 5.85853L8.55041 2.9252C9.35041 1.33353 10.6504 1.33353 11.4421 2.9252Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RewardIcons = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M10 12.4998C13.1066 12.4998 15.625 10.0747 15.625 7.08317C15.625 4.09163 13.1066 1.6665 10 1.6665C6.8934 1.6665 4.375 4.09163 4.375 7.08317C4.375 10.0747 6.8934 12.4998 10 12.4998Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.26613 11.2667L6.25781 17.4167C6.25781 18.1667 6.78282 18.5334 7.43282 18.225L9.66614 17.1667C9.84948 17.075 10.1578 17.075 10.3411 17.1667L12.5828 18.225C13.2245 18.525 13.7578 18.1667 13.7578 17.4167V11.1167"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M10 12.4998C13.1066 12.4998 15.625 10.0747 15.625 7.08317C15.625 4.09163 13.1066 1.6665 10 1.6665C6.8934 1.6665 4.375 4.09163 4.375 7.08317C4.375 10.0747 6.8934 12.4998 10 12.4998Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.26613 11.2667L6.25781 17.4167C6.25781 18.1667 6.78282 18.5334 7.43282 18.225L9.66614 17.1667C9.84948 17.075 10.1578 17.075 10.3411 17.1667L12.5828 18.225C13.2245 18.525 13.7578 18.1667 13.7578 17.4167V11.1167"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const APILogsIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M5.30859 7.92482C1.90859 8.16649 1.91693 13.0915 5.30859 13.3331H13.3586C14.3336 13.3415 15.2753 12.9748 16.0003 12.3165C18.3836 10.2332 17.1086 6.06647 13.9669 5.66647C12.8419 -1.11687 3.01694 1.45815 5.34194 7.92482"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3335V15.8335"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.9987 19.1668C10.9192 19.1668 11.6654 18.4206 11.6654 17.5002C11.6654 16.5797 10.9192 15.8335 9.9987 15.8335C9.07822 15.8335 8.33203 16.5797 8.33203 17.5002C8.33203 18.4206 9.07822 19.1668 9.9987 19.1668Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0013 17.5H11.668"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 17.5H5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BranchesIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M1.91016 6.48348V14.5918C1.91016 16.1751 3.03516 16.8251 4.40182 16.0418L6.36016 14.9251C6.78516 14.6835 7.49349 14.6585 7.93516 14.8835L12.3102 17.0751C12.7518 17.2918 13.4602 17.2751 13.8852 17.0335L17.4935 14.9668C17.9518 14.7001 18.3352 14.0501 18.3352 13.5168V5.40848C18.3352 3.82514 17.2102 3.17514 15.8435 3.95848L13.8852 5.07514C13.4602 5.31681 12.7518 5.34181 12.3102 5.11681L7.93516 2.93348C7.49349 2.71681 6.78516 2.73348 6.36016 2.97514L2.75182 5.04181C2.28516 5.30848 1.91016 5.95848 1.91016 6.48348Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.13281 3.3335V14.1668"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1094 5.5166V16.6666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CityIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M3.0148 7.07484C4.65646 -0.141827 15.3481 -0.133494 16.9815 7.08317C17.9398 11.3165 15.3065 14.8998 12.9981 17.1165C11.3231 18.7332 8.67313 18.7332 6.9898 17.1165C4.6898 14.8998 2.05646 11.3082 3.0148 7.07484Z"
      stroke={color}
      strokeWidth="1.3"
    />
    <path
      d="M9.99844 11.1917C11.4344 11.1917 12.5984 10.0276 12.5984 8.5917C12.5984 7.15576 11.4344 5.9917 9.99844 5.9917C8.5625 5.9917 7.39844 7.15576 7.39844 8.5917C7.39844 10.0276 8.5625 11.1917 9.99844 11.1917Z"
      stroke={color}
      strokeWidth="1.3"
    />
  </svg>
);

export const CouponIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M18.332 4.99984V7.0165C18.332 8.33317 17.4987 9.1665 16.182 9.1665H13.332V3.3415C13.332 2.4165 14.0904 1.6665 15.0154 1.6665C15.9237 1.67484 16.757 2.0415 17.357 2.6415C17.957 3.24984 18.332 4.08317 18.332 4.99984Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66797 5.83317V17.4998C1.66797 18.1915 2.4513 18.5832 3.0013 18.1665L4.4263 17.0998C4.75964 16.8498 5.2263 16.8832 5.5263 17.1832L6.90964 18.5748C7.23464 18.8998 7.76797 18.8998 8.09297 18.5748L9.49297 17.1748C9.78463 16.8832 10.2513 16.8498 10.5763 17.0998L12.0013 18.1665C12.5513 18.5748 13.3346 18.1832 13.3346 17.4998V3.33317C13.3346 2.4165 14.0846 1.6665 15.0013 1.6665H5.83464H5.0013C2.5013 1.6665 1.66797 3.15817 1.66797 4.99984Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.22656 11.4416L9.77656 6.8916"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.93553 11.2502H9.94301"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16209 7.08317H5.16957"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomerIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M14.9984 5.96651C14.9484 5.95817 14.8901 5.95817 14.8401 5.96651C13.6901 5.92484 12.7734 4.98317 12.7734 3.81651C12.7734 2.62484 13.7318 1.6665 14.9234 1.6665C16.1151 1.6665 17.0734 2.63317 17.0734 3.81651C17.0651 4.98317 16.1484 5.92484 14.9984 5.96651Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1383 12.0333C15.28 12.225 16.5383 12.025 17.4216 11.4333C18.5966 10.65 18.5966 9.36664 17.4216 8.58331C16.53 7.99164 15.2549 7.79163 14.1133 7.99163"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.97344 5.96651C5.02344 5.95817 5.08177 5.95817 5.13177 5.96651C6.28177 5.92484 7.19844 4.98317 7.19844 3.81651C7.19844 2.62484 6.24011 1.6665 5.04844 1.6665C3.85677 1.6665 2.89844 2.63317 2.89844 3.81651C2.90677 4.98317 3.82344 5.92484 4.97344 5.96651Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0023 12.1916C9.95234 12.1833 9.89401 12.1833 9.84401 12.1916C8.69401 12.1499 7.77734 11.2083 7.77734 10.0416C7.77734 8.84994 8.73568 7.8916 9.92734 7.8916C11.119 7.8916 12.0773 8.85827 12.0773 10.0416C12.069 11.2083 11.1523 12.1583 10.0023 12.1916Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.57656 14.8168C6.40156 15.6001 6.40156 16.8835 7.57656 17.6668C8.9099 18.5585 11.0932 18.5585 12.4266 17.6668C13.6016 16.8835 13.6016 15.6001 12.4266 14.8168C11.1016 13.9335 8.9099 13.9335 7.57656 14.8168Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MeetingRoomIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M4.16797 1.6665H15.668C16.2203 1.6665 16.668 2.11422 16.668 2.6665V14.5554C16.668 15.1077 16.2203 15.5554 15.668 15.5554H13.543M4.16797 1.6665V14.8087C4.16797 15.2516 4.45926 15.6417 4.88388 15.7675L12.2589 17.9527C12.8998 18.1426 13.543 17.6623 13.543 16.9939V5.19096C13.543 4.74809 13.2517 4.35797 12.8271 4.23216L4.16797 1.6665ZM10.418 10.9258V11.8517"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OrderIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M18.332 4.99984V7.0165C18.332 8.33317 17.4987 9.1665 16.182 9.1665H13.332V3.3415C13.332 2.4165 14.0904 1.6665 15.0154 1.6665C15.9237 1.67484 16.757 2.0415 17.357 2.6415C17.957 3.24984 18.332 4.08317 18.332 4.99984Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66797 5.83317V17.4998C1.66797 18.1915 2.45128 18.5832 3.00128 18.1665L4.4263 17.0998C4.75963 16.8498 5.22631 16.8832 5.52631 17.1832L6.90962 18.5748C7.23462 18.8998 7.76799 18.8998 8.09299 18.5748L9.49298 17.1748C9.78465 16.8832 10.2513 16.8498 10.5763 17.0998L12.0013 18.1665C12.5513 18.5748 13.3346 18.1832 13.3346 17.4998V3.33317C13.3346 2.4165 14.0846 1.6665 15.0013 1.6665H5.83464H5.0013C2.5013 1.6665 1.66797 3.15817 1.66797 4.99984V5.83317Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.5H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 10.8335H9.375"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReviewIcon2 = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M15.2667 9.99982C17.4333 9.99982 18.3333 9.16649 17.5333 6.43316C16.9917 4.59149 15.4083 3.00816 13.5667 2.46649C10.8333 1.66649 10 2.56649 10 4.73316V7.13316C10 9.16649 10.8333 9.99982 12.5 9.99982H15.2667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6652 12.2501C15.8902 16.1085 12.1902 18.9085 7.98189 18.2251C4.82356 17.7168 2.28189 15.1751 1.76523 12.0168C1.09023 7.82513 3.87356 4.12513 7.71523 3.3418"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OverviewIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M15.2667 9.99982C17.4333 9.99982 18.3333 9.16649 17.5333 6.43316C16.9917 4.59149 15.4083 3.00816 13.5667 2.46649C10.8333 1.66649 10 2.56649 10 4.73316V7.13316C10 9.16649 10.8333 9.99982 12.5 9.99982H15.2667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6652 12.2501C15.8902 16.1085 12.1902 18.9085 7.98189 18.2251C4.82356 17.7168 2.28189 15.1751 1.76523 12.0168C1.09023 7.82513 3.87356 4.12513 7.71523 3.3418"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M7.63411 9.05817C7.55078 9.04984 7.45078 9.04984 7.35911 9.05817C5.37578 8.9915 3.80078 7.3665 3.80078 5.3665C3.80078 3.32484 5.45078 1.6665 7.50078 1.6665C9.54245 1.6665 11.2008 3.32484 11.2008 5.3665C11.1924 7.3665 9.61745 8.9915 7.63411 9.05817Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6747 3.3335C15.2914 3.3335 16.5914 4.64183 16.5914 6.25016C16.5914 7.82516 15.3414 9.1085 13.7831 9.16683C13.7164 9.1585 13.6414 9.1585 13.5664 9.16683"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.46563 12.1335C1.44896 13.4835 1.44896 15.6835 3.46563 17.0252C5.75729 18.5585 9.51563 18.5585 11.8073 17.0252C13.824 15.6752 13.824 13.4752 11.8073 12.1335C9.52396 10.6085 5.76562 10.6085 3.46563 12.1335Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2852 16.6665C15.8852 16.5415 16.4518 16.2998 16.9185 15.9415C18.2185 14.9665 18.2185 13.3582 16.9185 12.3832C16.4602 12.0332 15.9018 11.7998 15.3102 11.6665"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WebsiteRequestIcon = ({
  color = defaultColor,
  width = 13,
  height = 13,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M6.5 1.0835V4.87516L7.58333 3.79183"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5013 4.87484L5.41797 3.7915"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.07422 7.0415H3.46297C3.6688 7.0415 3.85297 7.15525 3.94505 7.33942L4.5788 8.60692C4.76297 8.97525 5.13672 9.20817 5.54839 9.20817H7.46047C7.87214 9.20817 8.24588 8.97525 8.43005 8.60692L9.0638 7.33942C9.15588 7.15525 9.34547 7.0415 9.54589 7.0415H11.9076"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.79036 2.2373C1.87286 2.51897 1.08203 3.64564 1.08203 5.95855V8.12522C1.08203 10.8336 2.16536 11.9169 4.8737 11.9169H8.1237C10.832 11.9169 11.9154 10.8336 11.9154 8.12522V5.95855C11.9154 3.64564 11.1245 2.51897 9.20703 2.2373"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WorkshopIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M4.9987 1.6665H14.9987C15.9154 1.6665 16.6654 2.4165 16.6654 3.33317V6.93318H3.33203V3.33317C3.33203 2.4165 4.08203 1.6665 4.9987 1.6665Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33203 6.93311V9.89977C3.33203 10.7998 3.81539 11.6331 4.60706 12.0748L7.07369 13.4664C7.59869 13.7581 7.92371 14.3165 7.92371 14.9165V16.6664C7.92371 17.5831 8.67371 18.3331 9.59037 18.3331H10.4237C11.3404 18.3331 12.0904 17.5831 12.0904 16.6664V14.9165C12.0904 14.3165 12.4154 13.7581 12.9404 13.4664L15.407 12.0748C16.1904 11.6331 16.682 10.7998 16.682 9.89977V6.93311H3.33203Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WorkspaceIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M4.64286 15.3571H15.3571M4.64286 15.3571C3.45939 15.3571 2.5 14.3978 2.5 13.2143V8.39286C2.5 7.50525 3.21954 6.78571 4.10714 6.78571C4.29499 6.78571 4.4753 6.81794 4.64286 6.87716M4.64286 15.3571V17.5M15.3571 15.3571C16.5406 15.3571 17.5 14.3978 17.5 13.2143V8.39286C17.5 7.50525 16.7804 6.78571 15.8929 6.78571C15.705 6.78571 15.5247 6.81794 15.3571 6.87716M15.3571 15.3571V17.5M4.64286 6.87716C5.26707 7.09779 5.71429 7.6931 5.71429 8.39286V11.0714H14.2857V8.39286C14.2857 7.6931 14.7329 7.09779 15.3571 6.87716M4.64286 6.87716V6.78571C4.64286 4.41878 6.56164 2.5 8.92857 2.5H11.0714C13.4383 2.5 15.3571 4.41878 15.3571 6.78571V6.87716"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WSManagementIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C14.1667 1.6665 15 3.90817 15 6.6665V8.33317"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 18.3335H5.83464C2.5013 18.3335 1.66797 17.5002 1.66797 14.1668V12.5002C1.66797 9.16683 2.5013 8.3335 5.83464 8.3335H14.168C17.5013 8.3335 18.3346 9.16683 18.3346 12.5002V14.1668C18.3346 17.5002 17.5013 18.3335 14.168 18.3335Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OfficeIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <circle
        cx="6.5"
        cy="4.5"
        r="1.5"
        stroke={color}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
      <path
        d="M2 9H18"
        stroke={color}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
      <path
        d="M3 9V17.3C3 17.4105 3.08954 17.5 3.2 17.5H4.87639C4.95215 17.5 5.0214 17.4572 5.05528 17.3894L5.44472 16.6106C5.4786 16.5428 5.54785 16.5 5.62361 16.5H14.3764C14.4521 16.5 14.5214 16.5428 14.5553 16.6106L14.9447 17.3894C14.9786 17.4572 15.0479 17.5 15.1236 17.5H16.8C16.9105 17.5 17 17.4105 17 17.3V9"
        stroke={color}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
      <path
        d="M3.5 9C3.5 7.89543 4.39543 7 5.5 7H7C8.10457 7 9 7.89543 9 9"
        stroke={color}
        strokeWidth="0.6"
      />
      <path
        d="M12 9L13 5.5H14L15 9"
        stroke={color}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
      <path
        d="M12.5 7H10.5C10.2239 7 10 6.77614 10 6.5V2.8C10 2.35817 10.3582 2 10.8 2H16.2C16.6418 2 17 2.35817 17 2.8V6.5C17 6.77614 16.7761 7 16.5 7H14.5"
        stroke={color}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const HotDeskIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M19.2988 7.29883H17.7988V15.2988H15.6992V11.2988H9.69922V7.29883H3.79883V15.2988H1.69922V7.29883H0.699219V4.69922H19.2988V7.29883ZM2.29883 14.6992H3.19922V7.29883H2.29883V14.6992ZM16.2988 14.6992H17.1992V7.29883H16.2988V14.6992ZM10.2988 10.6992H15.6992V9.29883H14V9.5H12V9.29883H10.2988V10.6992ZM10.2988 8.69922H15.6992V7.29883H14V7.5H12V7.29883H10.2988V8.69922ZM1.29883 6.69922H18.6992V5.29883H1.29883V6.69922Z"
        fill={color}
      />
    </svg>
  );
};

export const PlanAndPricingIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M18.3333 5.00033V7.01699C18.3333 8.33366 17.4999 9.16699 16.1833 9.16699H13.3333V3.34199C13.3333 2.41699 14.0916 1.66699 15.0166 1.66699C15.9249 1.67533 16.7583 2.04199 17.3583 2.64199C17.9583 3.25032 18.3333 4.08366 18.3333 5.00033Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66675 5.83366V17.5003C1.66675 18.192 2.45008 18.5837 3.00008 18.167L4.42508 17.1003C4.75841 16.8503 5.22508 16.8837 5.52508 17.1837L6.90841 18.5753C7.23341 18.9003 7.76675 18.9003 8.09175 18.5753L9.49175 17.1753C9.78341 16.8837 10.2501 16.8503 10.5751 17.1003L12.0001 18.167C12.5501 18.5753 13.3334 18.1837 13.3334 17.5003V3.33366C13.3334 2.41699 14.0834 1.66699 15.0001 1.66699H5.83341H5.00008C2.50008 1.66699 1.66675 3.15866 1.66675 5.00033V5.83366Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.8418H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.50879H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99634 10.833H5.00382"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99634 7.5H5.00382"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DemoRequestIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M2.5 3.3335C2.5 2.4135 3.24667 1.66683 4.16667 1.66683H15.8333C16.7533 1.66683 17.5 2.4135 17.5 3.3335V11.6668C17.5 12.5868 16.7533 13.3335 15.8333 13.3335H6.66667L3.33333 16.6668V3.3335H2.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 6.6665H13.3327"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 9.1665H10.8327"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.166 15L16.2494 18.3333L17.4993 16.2499L18.7493 18.3333L20.8327 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="scale(0.8) translate(2.5, 2)"
      />
    </svg>
  );
};

export const OrganizationIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      {/* Building */}
      <path
        d="M3.33301 17.5V6.66667C3.33301 5.74667 4.07967 5 4.99967 5H14.9997C15.9197 5 16.6663 5.74667 16.6663 6.66667V17.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Roof */}
      <path
        d="M1.66699 17.5H18.3337"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Windows */}
      <path d="M6.66699 8.3335H8.33366V9.16683H6.66699V8.3335Z" fill={color} />
      <path d="M11.667 8.3335H13.3337V9.16683H11.667V8.3335Z" fill={color} />
      <path
        d="M6.66699 11.6665H8.33366V12.4998H6.66699V11.6665Z"
        fill={color}
      />
      <path d="M11.667 11.6665H13.3337V12.4998H11.667V11.6665Z" fill={color} />
      {/* Door */}
      <path
        d="M9.16699 17.5V13.3333H10.8337V17.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
